module.exports = __webpack_public_path__ + "img/194.e8d54ed7.svg";